module.exports = __webpack_public_path__ + "img/picture-in-template.863c1149.svg";